// LoadingOverlayManager.js
let setVisible = null;

const LoadingOverlayManager = {
  register(callback) {
    setVisible = callback;
  },
  show() {
    if (setVisible) setVisible(true);
  },
  hide() {
    if (setVisible) setVisible(false);
  }
};

export default LoadingOverlayManager;
